import { TFunction } from 'react-i18next'

const PATIENT_NOT_MATCHING_TREATMENT_BUNDLE = 'api_errors_patient_not_matching_age_criteria_for_treatment_bundle'

export const formatError = (errorKey: string, t: TFunction): string => {
  if (errorKey === PATIENT_NOT_MATCHING_TREATMENT_BUNDLE) {
    return t(errorKey, { patientScreenLink: '#/patient', treatmentScreenLink: '#/treatment' })
  }

  return t(errorKey)
}
